module.exports = __webpack_public_path__ + "img/gift2.0a7a1e45.png";